// nirvana-custom.js
// Nirvana Designer Studio

(function () {

  document.addEventListener('click', function (e) {

    // IMPORTANT: listen for both Square Wishlist elements
    var btn = e.target.closest(
      '.Vtl-WishlistButton__AddToWishlist, .Vtl-WishlistButton__IconWrapper'
    );

    if (!btn) return;


    // ============================================================
    // 1. LOGIN CHECK
    // ============================================================

    if (
      !window.__nirvana__ ||
      window.__nirvana__.isLoggedIn !== true
    ) {

      console.log('[NIRVANA] Guest wishlist click → opening login');

      // Block Wishlist by Square from adding the product
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();


      // Trigger OTP login
      var otpTrigger = document.createElement('button');

      otpTrigger.type = 'button';
      otpTrigger.className = 'account-button';
      otpTrigger.style.display = 'none';

      document.body.appendChild(otpTrigger);

      otpTrigger.click();

      otpTrigger.remove();

      return;
    }


    // ============================================================
    // 2. LOGGED-IN CUSTOMER → CONTINUE WISHLIST ACTION
    // ============================================================

    console.log('[NIRVANA] Logged-in wishlist click');


    // ============================================================
    // 3. GET PRODUCT DATA
    // ============================================================

    var productData =
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product;


    var productId =
      (productData && productData.id) ||
      btn.dataset.productId ||
      '';


    var productName =
      (productData && productData.title) ||
      btn.dataset.productTitle ||
      btn.getAttribute('aria-label') ||
      '';


    var vendor =
      (productData && productData.vendor) ||
      '';


    var productType =
      (productData && productData.type) ||
      '';


    var variantId =
      (productData && productData.selectedVariantId) ||
      btn.dataset.variantId ||
      '';


    var price =
      (productData && productData.price)
        ? productData.price / 100
        : 0;


    var currency =
      (
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
      ) || 'INR';


    // ============================================================
    // 4. BUILD SHOPIFY EVENT DATA
    // ============================================================

    var wishlistData = {

      product_id: String(productId),

      variant_id: String(variantId),

      item_name: productName,

      item_brand: vendor,

      item_category: productType,

      price: Number(price),

      currency: currency,

      quantity: 1,

      page_url: window.location.href

    };


    // ============================================================
    // 5. PUBLISH SHOPIFY EVENT
    // ============================================================

    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {

      Shopify.analytics.publish(
        'nirvana:add_to_wishlist',
        wishlistData
      );

      console.log(
        '[NIRVANA] add_to_wishlist published:',
        wishlistData
      );

    } else {

      console.warn(
        '[NIRVANA] Shopify.analytics.publish unavailable'
      );

    }

  }, true);



  // ── 2. Auto-fill email in OTP+ signup ─────────────────────────────────
  (function () {
    var cachedPhone = '';

    function cleanPhone(value) {
      return (value || '').replace(/\D/g, '');
    }

    function setInputValue(input, value) {
      if (!input) return;
      var setter = Object.getOwnPropertyDescriptor(
        HTMLInputElement.prototype, 'value'
      ).set;
      setter.call(input, value);
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function tryAutofillNcaEmail() {
      var phoneInput = document.querySelector('#nca-phone');
      if (phoneInput && phoneInput.value) {
        cachedPhone = cleanPhone(phoneInput.value);
      }

      var form = document.querySelector('.nca-account-details-form');
      if (!form) return;

      var emailInput = form.querySelector('#nca-email');
      if (!emailInput) return;

      if (!cachedPhone) {
        var currentPhoneInput = document.querySelector('#nca-phone');
        if (currentPhoneInput) {
          cachedPhone = cleanPhone(currentPhoneInput.value);
        }
      }

      if (!cachedPhone) return;

      var generatedEmail = cachedPhone + '@nirvanastores.com';
      if (emailInput.value !== generatedEmail) {
        setInputValue(emailInput, generatedEmail);
        console.log('[Nirvana] NCA email auto-filled:', generatedEmail);
      }
    }

    document.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'nca-phone') {
        cachedPhone = cleanPhone(e.target.value);
        tryAutofillNcaEmail();
      }
    }, true);

    var emailObserver = new MutationObserver(function () {
      tryAutofillNcaEmail();
    });
    emailObserver.observe(document.documentElement, {
      childList: true,
      subtree:   true
    });

    tryAutofillNcaEmail();
  })();


  // ── 3. Skip name filling in OTP+ Account Details ──────────────────────
  (function () {
    var historyGuardAdded = false;
    var skipInProgress    = false;

    function getForm() {
      return document.querySelector('.nca-account-details-form');
    }

    function getSubmitButton(form) {
      return form && form.querySelector(
        '.nca-account-details-submit .continueButton'
      );
    }

    function submitAsSkip(reason) {
      var form = getForm();
      if (!form || skipInProgress) return false;

      var button = getSubmitButton(form);
      if (!button || button.disabled) return false;

      skipInProgress = true;
      console.log('[Nirvana] Account Details submitted via:', reason);

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(button);
      } else {
        button.click();
      }

      setTimeout(function () {
        if (getForm()) { skipInProgress = false; }
      }, 2000);

      return true;
    }

    function updateAccountDetailsUI() {
      var form = getForm();

      document.querySelectorAll('.otp-account-modal').forEach(function (modal) {
        var closeButton = modal.querySelector('.otp-account-modal__close');
        if (!closeButton) return;

        var h2 = modal.querySelector('h2');
        var shouldHide = !!modal.querySelector('.nca-account-details-form') ||
                         (h2 && h2.textContent.trim().toLowerCase() === "you're signed in");

        if (shouldHide) {
          closeButton.style.setProperty('display', 'none', 'important');
          closeButton.dataset.nirvanaHidden = 'true';
        } else if (closeButton.dataset.nirvanaHidden === 'true') {
          closeButton.style.removeProperty('display');
          delete closeButton.dataset.nirvanaHidden;
        }
      });

      if (!form) {
        historyGuardAdded = false;
        skipInProgress    = false;
        return;
      }

      var firstName = form.querySelector('#nca-first-name');
      var lastName  = form.querySelector('#nca-last-name');
      var button    = getSubmitButton(form);

      if (!firstName || !lastName || !button || button.disabled) return;

      var hasName = firstName.value.trim() !== '' || lastName.value.trim() !== '';
      var label   = hasName ? 'Update' : 'Continue';

      if (button.textContent.trim() !== label) {
        button.textContent = label;
      }
      button.setAttribute('aria-label', hasName ? 'Update account' : 'Skip account details');

      if (!historyGuardAdded) {
        try {
          history.pushState({ nirvanaOtpAccountDetails: true }, '', window.location.href);
          historyGuardAdded = true;
        } catch (err) {
          console.warn('[Nirvana] History guard failed:', err);
        }
      }
    }

    document.addEventListener('click', function (e) {
      if (!getForm()) return;
      var backdrop = e.target.closest('.otp-account-modal-backdrop');
      if (!backdrop || e.target !== backdrop) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      submitAsSkip('backdrop');
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !getForm()) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      submitAsSkip('escape');
    }, true);

    window.addEventListener('popstate', function () {
      if (!getForm()) return;
      try {
        history.pushState({ nirvanaOtpAccountDetails: true }, '', window.location.href);
      } catch (err) {}
      submitAsSkip('browser-back');
    });

    window.addEventListener('pagehide',     function () { if (getForm()) submitAsSkip('pagehide');     });
    window.addEventListener('beforeunload', function () { if (getForm()) submitAsSkip('beforeunload'); });

    document.addEventListener('input', function (e) {
      if (e.target && (e.target.id === 'nca-first-name' || e.target.id === 'nca-last-name')) {
        requestAnimationFrame(updateAccountDetailsUI);
      }
    }, true);

    var skipObserver = new MutationObserver(function () {
      updateAccountDetailsUI();
    });
    skipObserver.observe(document.documentElement, {
      childList:     true,
      subtree:       true,
      characterData: true
    });

    updateAccountDetailsUI();
  })();


  // ── 4. UX changes for signup popup ────────────────────────────────────
  (function () {

    var NEW_HEADING = 'Sign In & Save What You Love';

    var NEW_SUBHEADING = [
      '<div style="text-align:center;line-height:1.5;width:100%;">',

        '<div style="font-size:15px;font-weight:600;margin-bottom:7px;">',
          '✨ Keep your favourites saved whenever you come back',
        '</div>',

        '<div style="font-size:15px;font-weight:600;margin-bottom:12px;">',
          '✨ Check dress-specific offers, if available, in your cart',
        '</div>',

        '<div style="font-size:13.5px;line-height:1.45;opacity:0.82;margin-bottom:12px;">',
          'A quick verification helps us protect genuine shoppers',
          ' as online scams continue to increase.',
        '</div>',

        '<div style="display:inline-block;padding:8px 14px;margin:2px auto 12px;border-radius:20px;background:rgba(0,0,0,0.06);font-size:13px;font-weight:700;line-height:1.3;">',
          'Sorry for the extra step ♡',
        '</div>',

        '<div style="font-size:13px;font-weight:600;line-height:1.4;">',
          'No spam. No unwanted messages. Nirvana Promise.',
        '</div>',

      '</div>'
    ].join('');

    function updateLoginPopup() {
      document.querySelectorAll(
        'h1, h2, h3, h4, h5, h6, p, span, div'
      ).forEach(function (el) {

        if (el.children.length > 3) return;

        var text = el.textContent.trim();

        if (
          text === 'Sign in to your account' &&
          !el.dataset.nirvanaHeadingChanged
        ) {
          el.textContent = NEW_HEADING;
          el.dataset.nirvanaHeadingChanged = 'true';
          el.style.textAlign    = 'center';
          el.style.width        = '100%';
          el.style.lineHeight   = '1.25';
          el.style.fontWeight   = '700';
          el.style.marginBottom = '1rem';
        }

        if (
          text === "Choose how you'd like to continue" &&
          !el.dataset.nirvanaSubheadingChanged
        ) {
          el.innerHTML = NEW_SUBHEADING;
          el.dataset.nirvanaSubheadingChanged = 'true';
          el.style.textAlign = 'center';
          el.style.width     = '100%';
        }

      });
    }

    updateLoginPopup();

    var popupObserver = new MutationObserver(function () {
      updateLoginPopup();
    });
    popupObserver.observe(document.body, {
      childList: true,
      subtree:   true
    });

  })();

})();
